// Starting point of the game in the browser.
import './styles.css';
import { fontsReady } from './images.ts';
import { showMainMenu } from './menu.ts';
import { restoreSavedDeck } from './deckMemory.ts';
import { installLongPress } from './touch.ts';
import { resumeAccount } from './accounts.ts';

if (__DEV__) {
  // reload the page whenever a file changes during `npm run dev`
  new EventSource('/esbuild').addEventListener('change', () => location.reload());
}

document.addEventListener('contextmenu', (e) => {
  // the game uses right-click for its own menus
  if ((e.target as HTMLElement).closest('.card-tile, .hand-card, .table-screen, .modal')) e.preventDefault();
});

restoreSavedDeck(); // the last saved deck, kept in this browser
void resumeAccount(); // still signed in to an account on this browser? (checked with the game server in the background)
installLongPress(); // touch screens: press and hold = right-click
await fontsReady();
showMainMenu();
